import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import {Button, Link} from "@mui/material";
import useInterventionRepository from "../../../../../../repository/emergency/useInterventionRepository";
import {useEffect, useRef, useState} from "react";
import isNull from "../../../../../../mixin/isNull";
import Box from "@mui/material/Box";
import {ArrowDownward, ArrowUpward, CheckCircle, CopyAll, GpsFixed} from "@mui/icons-material";
import useOrderAddressRepository from "../../../../../../repository/emergency/useOrderAddressRepository";
import QualityInspection from "../../../../../../entity/emergency/QualityInspection";
import useQualityInspectionRepository from "../../../../../../repository/emergency/useQualityInspectionRepository";
import NotifyAppointment from "./NotifyAppointment";
import LoadingData from "../common/LoadingData";
import useAlert from "../../../../../../use/useAlert";
import useClipboard from "../../../../../../use/useClipboard";
import PopperWrapper from "../../../../../../material/popper/PopperWrapper";
import useEventDispatcher from "../../../../../../use/useEventDispatcher";
import parameter from "../../../../../../enum/parameter";

export default function ({qualityInspectionId, clientId, interventionId, orderId}) {
    const alert = useAlert();
    const clipboard = useClipboard();
    const eventDispatcher = useEventDispatcher();
    const qualityInspectionRepository = useQualityInspectionRepository();
    const interventionRepository = useInterventionRepository();
    const orderAddressRepository = useOrderAddressRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneById(interventionId).select();
    /** @type OrderAddress */
    const orderAddress = orderAddressRepository.findOneByOrderId(orderId).select();
    const [loading, setLoading] = useState(false);
    const googleMapLink = useRef();
    const nextStepButtonRef = useRef();
    const openMapButtonRef = useRef();
    const copyCoordinateButtonRef = useRef();

    useEffect(() => {
        interventionRepository.findOneById(interventionId).exec();
        orderAddressRepository.findOneByOrderId(orderId).exec(false);
    }, []);

    useEffect(() => {
        if (isNull(intervention) || isNull(orderAddress)) return;

        eventDispatcher.launcher("open-gps");

        setTimeout(() => eventDispatcher.launcher("copy-coordinate"), parameter.POPUP_TIME);
        setTimeout(() => eventDispatcher.launcher("next-step-available"), parameter.POPUP_TIME * 2);
    }, [JSON.stringify(intervention), JSON.stringify(orderAddress)]);

    const handleOpenMap = () => {
        googleMapLink.current.click();
    }

    const handleCopyCoordinate = () => {
        clipboard(`${orderAddress.getLat()},${orderAddress.getLng()}`);

        alert.success("Copié !");
    }

    const nextStep = async () => {
        setLoading(true);

        const res = await qualityInspectionRepository.update(qualityInspectionId, "current_step", {
            quality_inspection: {
                current_step: QualityInspection.STEP_TRAVEL
            }
        });

        if (!res) setLoading(false);
    }

    if (isNull(intervention) || isNull(orderAddress)) return <LoadingData/>;

    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyAppointment appointment={intervention.getAppointment()}/>
                </Box>
                <Box mt={10} display="flex" justifyContent="center">
                    <Button
                        startIcon={<GpsFixed/>}
                        variant={"contained"}
                        sx={{width: "80%"}}
                        onClick={handleOpenMap}
                        ref={openMapButtonRef}
                        data-test="button-open-map"
                    >
                        Ouvrir mon GPS
                    </Button>
                    <PopperWrapper
                        elementRef={openMapButtonRef}
                        placement={"bottom"}
                        content={"Ouvrez google map pour vous rendre chez le sociétaire"}
                        triggeringEvent={"open-gps"}
                        autoCloseAfter={parameter.POPUP_TIME}
                        displayCloseButton={false}
                        contentColor={parameter.POPUP_COLOR}
                        icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                    />
                </Box>
                <Box mt={5} display={"flex"} justifyContent="center">
                    <Button
                        startIcon={<CopyAll/>}
                        variant={"contained"}
                        sx={{width: "80%"}}
                        onClick={handleCopyCoordinate}
                        ref={copyCoordinateButtonRef}
                        data-test="button-open-map"
                    >
                        Copier les coordonnées GPS
                    </Button>
                    <PopperWrapper
                        elementRef={copyCoordinateButtonRef}
                        placement={"bottom"}
                        content={"Ou copiez les coordonnées et collez les dans votre GPS"}
                        triggeringEvent={"copy-coordinate"}
                        autoCloseAfter={parameter.POPUP_TIME}
                        displayCloseButton={false}
                        contentColor={parameter.POPUP_COLOR}
                        icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                    />
                </Box>

                <Link
                    ref={googleMapLink}
                    href={`https://www.google.com/maps/dir/?api=1&origin=Current%20Location&destination=${orderAddress.getLat()},${orderAddress.getLng()}`}
                    target={"_blank"}
                    color={"inherit"}
                    underline={"none"}
                />
            </Body>
            <Footer>
                <PopperWrapper
                    elementRef={nextStepButtonRef}
                    placement={"top"}
                    content={"Quand vous arrivez chez le sociétaire, passez à l'étape suivante"}
                    triggeringEvent={"next-step-available"}
                    autoCloseAfter={parameter.POPUP_TIME}
                    displayCloseButton={false}
                    contentColor={parameter.POPUP_COLOR}
                    icon={<ArrowDownward color={parameter.POPUP_COLOR}/>}
                />
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    disabled={loading}
                    ref={nextStepButtonRef}
                    data-test="button-next-step"
                >
                    Je suis arrivé chez le sociétaire
                </Button>
            </Footer>
        </>
    )
}